<template>
<v-flex mb-5 v-if="!badURL">

    <v-layout my-5>
        <v-flex xs12 xl8 offset-xl2>
            <v-layout align-center>
                <h1 class="text-xs-left display-2 my-2">Semester Manager</h1>
                <v-spacer></v-spacer>
                <h1 class="text-xs-left display-2 my-2">{{ semester.name }}</h1>
            </v-layout>
        </v-flex>
    </v-layout>

    <v-layout row wrap>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <semester-edit-form :semester="semester"></semester-edit-form>
        </v-flex>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <semester-notes-manager :semester="semester"></semester-notes-manager>
        </v-flex>
    </v-layout>

</v-flex>
<v-flex v-else>
    <semester-not-found></semester-not-found>
</v-flex>
</template>

<script>
import EditForm from './EditForm'
import NotesManager from './NotesManager'
import NotFound from '@/components/NotFound'

export default {
    components: {
        SemesterEditForm: EditForm,
        SemesterNotesManager: NotesManager,
        SemesterNotFound: NotFound
    },
    computed: {
        badURL() {
            return Object.keys(this.$store.state.semesterModule.semesterData).length === 0
        },
        semester() {
            return this.$store.state.semesterModule.semesterData
        },
    },
    created() {
        this.$store.dispatch('getSemesterData', this.getSemesterID(this.$route.params.semester_slug))
    },
    beforeRouteUpdate(to, from, next) {
        if (to.path !== from.path) {
            this.$store.dispatch('getSemesterData', this.getSemesterID(to.params.semester_slug))
        }
        this.$root.$emit('resetEditOptions') // when user switches semesters we disable name edit field && deselect grade level
        next()
    },
    methods: {
        getSemesterID(slug) {
            let slugArray = slug.split('_')
            return slugArray[1]
        }
    }
}
</script>
